import type { SignatureColors } from "./signature";

/** The signature's two colours (the signature HTML and role round, 2026-10-28; brief rule 3, migration 0115). Null in a column means the
 *  default: the light grey below for the text, the workspace's accent for links (read at send, so a changed accent is followed). */

/** the palette's own blue, the accent of a workspace that chose none (moved here from the web app so the sender can fall back to it) */
export const DEFAULT_ACCENT = "#2271b1";
/** the default text colour: a neutral grey that still reads at 4.5:1 on white mail (4.74:1) */
export const SIGNATURE_TEXT_COLOR = "#737373";
/** the text colour presets under the editor: the default first, then darker greys and black */
export const SIGNATURE_TEXT_PRESETS = [
  { id: "light-grey", label: "Light grey", hex: SIGNATURE_TEXT_COLOR }, { id: "grey", label: "Grey", hex: "#525252" },
  { id: "dark-grey", label: "Dark grey", hex: "#404040" }, { id: "charcoal", label: "Charcoal", hex: "#262626" }, { id: "black", label: "Black", hex: "#000000" },
] as const;

export type SignatureColorPair = { color: string | null; linkColor: string | null };
/** the pair that applies: the project's while it uses its own signature, else the workspace's; a null takes the default (the grey; the
 *  accent, else the palette's blue) */
export function signatureColorsOf(o: { own: boolean; project: SignatureColorPair; workspace: SignatureColorPair; accent: string | null | undefined }): SignatureColors {
  const pair = o.own ? o.project : o.workspace;
  return { text: pair.color ?? SIGNATURE_TEXT_COLOR, link: pair.linkColor ?? o.accent ?? DEFAULT_ACCENT };
}
